import type { WalletTransactionEntity } from "@/modules/dashboard/cards/types/wallets-api.types";

/**
 * One props object, two faces. The table (from `xl` up) and the cards (below it) render the same rows and the
 * same judgement, so a row can never read differently depending on the width it is seen at.
 */
export interface CardWalletMovementsListProps {
  movements: WalletTransactionEntity[];
  isLoading: boolean;
  /** Resolves "Tú" in the author column without a second request. */
  currentUserId: string | null;
  /** `provider_transaction_id` of the movement the operator asked to see — its row is tinted. */
  highlightedProviderTxId: string | null;
}

const SHORT_DATE: Intl.DateTimeFormatOptions = { day: "numeric", month: "short" };
const TIME: Intl.DateTimeFormatOptions = { hour: "2-digit", minute: "2-digit" };

/** `14 oct` — the table's first line, where the year is noise and the day is what is scanned. */
export function movementShortDate(value: string, locale: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString(locale, SHORT_DATE);
}

export function movementTime(value: string, locale: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleTimeString(locale, TIME);
}
